// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"799a9946","47":"b8996096","49":"e39c0904","262":"6bbf2f69","274":"71fc6c6c","548":"d72181d8","747":"8cd2faf8","873":"034df2ab","924":"453d9134","971":"fc063ecd"}[chunkId] + ".chunk.js";
};